// Computes live unrealized PnL + net for a wind cycle using WS price ticks.
// Returns values that update on every price tick without re-fetching detail.
import { useLivePrice } from "@/providers/ws-provider";
import type { WindCycle, WindSession } from "@/types/api";

const TAKER_FEE_RATE = 0.0007;

interface WindLivePnl {
  livePrice: number | null;
  unrealized: number;
  net: number;
}

export function useWindLivePnl(
  session: WindSession | undefined,
  latestCycle: WindCycle | null | undefined,
  realizedPnl: number
): WindLivePnl {
  const symbol = session?.symbol ?? "";
  const livePrice = useLivePrice(symbol);

  const cycleStatus = latestCycle?.status;
  const isLive = cycleStatus === "open" || cycleStatus === "closing";

  let unrealized = 0;
  if (isLive && latestCycle?.entry_price && livePrice) {
    const dir = latestCycle.direction === "long" ? 1 : -1;
    const qty = latestCycle.quantity ?? 0;
    const closeFee = livePrice * qty * TAKER_FEE_RATE;
    unrealized =
      (livePrice - latestCycle.entry_price) * qty * dir -
      (latestCycle.entry_fee ?? 0) -
      closeFee;
  }

  return { livePrice, unrealized, net: realizedPnl + unrealized };
}
